export default function define(runtime, observer) {
  const main = runtime.module();
  main.variable(observer()).define(["md"], function(md){return(
md`# Polygon Attributes`
)});
  main.variable(observer("report")).define("report", ["html","title","attributes","dd"], function(html,title,attributes,dd){return(
html`${title}
<div class='report-attribute-list'>
${attributes.map(dd)}
</div>
`
)});
  main.variable(observer("title")).define("title", ["polygonSubject","html","DOM"], function(polygonSubject,html,DOM)
{
  return polygonSubject.title ? html`<h3>${DOM.text(polygonSubject.title)}</h3>` : '';
}
);
  main.variable(observer("viewof map")).define("viewof map", ["html","mapHeight","mapWidth","ol","features","tileSource","mapUrl"], function*(html,mapHeight,mapWidth,ol,features,tileSource,mapUrl)
{
  const div = html`<div style="height: ${mapHeight}px; width: ${mapWidth}px; background-color:#78ABCB !important;"/>`;
  yield div;
  const source = new ol.source.Vector({
        features,
        projection: 'EPSG:2193',
        crossOrigin: 'anonymous',
        
      });
  
  const hdpi = true;
  
  let map = new ol.Map({
    target: div,
    projection: 'EPSG:2193',
    view: new ol.View({
      resolutions: [8960, 4480, 2240, 1120, 560, 280, 140, 70, 28, 14, 7, 2.8, 1.4, 0.7, 0.28, 0.14, 0.07],
      projection: 'EPSG:2193'
    }),
    controls: [],
    interactions: [],
    layers: [
      new ol.layer.Tile({
        source: tileSource({
          url: mapUrl,
          layerName:'topobasemap_notext',
          crossOrigin: 'anonymous',
          // nocache: Math.random(),
          hdpi
        })
      }),
      new ol.layer.Tile({
        source: tileSource({
            url: mapUrl,
            layerName:'water_transport_text',
            crossOrigin: 'anonymous',
            // nocache: Math.random(),
            hdpi
        })
      }),
      new ol.layer.Vector({
        source
      })
     ]
  });
  
  map.getView().fit(source.getExtent(), {size:map.getSize()});
  
  return new Promise(resolve => {
    map.once('rendercomplete', () => {
      div.dispatchEvent(new CustomEvent("input"));
      resolve(div);
    });
  }); 
}
);
  main.variable(observer("map")).define("map", ["Generators", "viewof map"], (G, _) => G.input(_));
  main.variable(observer("mapLoaded")).define("mapLoaded", ["map"], function(map)
{
  map;
  return true
}
);
  main.variable(observer()).define(["html"], function(html){return(
html`<h3>Example subject</h3>`
)});
  main.variable(observer("polygonSubject")).define("polygonSubject", function()
{
  return {
        "id": 111,
        "kind": "custom",
        "geometryType": "Polygon",
        "featureCollection": {
          "type": "FeatureCollection",
          "features": [
            {
              "type": "Feature",
              "geometry": {
                "type": "Polygon",
                "coordinates": [
                  [
                    [
                      1691578,
                      5644828
                    ],
                    [
                      1690010,
                      5636176
                    ],
                    [
                      1694994,
                      5636848
                    ],
                    [
                      1693006,
                      5649504
                    ],
                    [
                      1691578,
                      5644828
                    ]
                  ]
                ]
              },
              "properties": null
            }
          ]
        },
        "title": "Taranaki Slope",
        "sourceLayerId": 0,
        "srid": 2193,
        "member": 1
      }
}
);
  main.variable(observer()).define(["html"], function(html){return(
html`<h3>Implementation details</h3>`
)});
  main.variable(observer("mapUrl")).define("mapUrl", function(){return(
'https://portals-maps.landcareresearch.co.nz/mapcache/portals/wmts/?'
)});
  main.variable(observer("mapWidth")).define("mapWidth", function(){return(
140
)});
  main.variable(observer("mapHeight")).define("mapHeight", function(){return(
140
)});
  main.variable(observer("attributes")).define("attributes", ["areaHa"], function(areaHa)
{
  return [
    {
      name: 'Approximate area',
      val: areaHa
    }
  ];
}
);
  main.variable(observer("areaResponse")).define("areaResponse", function()
{
  return {area: 10000 * 573.33}
}
);
  main.variable(observer("areaHa")).define("areaHa", ["areaResponse"], function(areaResponse){return(
`${areaResponse && areaResponse.area !== undefined && areaResponse.area !== null ? Math.round(areaResponse.area / 10000.0).toLocaleString()+'ha' : 'unavailable'}`
)});
  main.variable(observer("dd")).define("dd", ["html","DOM"], function(html,DOM){return(
(attr) => html`<div class='report-attribute'>
 <div class='report-attribute-title'>${DOM.text(attr.name)}</div>
 <div class='report-attribute-value'>${DOM.text(attr.val)}</div>
</div>`
)});
  main.variable(observer("fmt")).define("fmt", ["ol"], function(ol){return(
new ol.format.GeoJSON()
)});
  main.variable(observer("features")).define("features", ["fmt","polygonSubject"], function(fmt,polygonSubject){return(
fmt.readFeatures(polygonSubject.featureCollection)
)});
  main.variable(observer("tileSource")).define("tileSource", ["ol","defaultResolutions"], function(ol,defaultResolutions){return(
(options) => {
  let projExtent = [274000, 3087000, 3327000, 7173000];

  let tileGrid = new ol.tilegrid.WMTS({
    origin: ol.extent.getTopLeft(projExtent),
    extent: projExtent,
    resolutions: defaultResolutions,
    matrixIds: ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16"]
  });

  let matrixSet = options.hdpi ? "NZTM2000HDPI" : "NZTM2000";
  return new ol.source.WMTS({
    tileGrid: tileGrid,
    projection: "EPSG:2193",
    url: options.url,
    format: 'jpeng',
    layer: options.layerName + (options.hdpi ? '-HDPI' : ''),
    style: 'default',
    tilePixelRatio: options.hdpi ? 2 : 1,
    matrixSet,
    // requestEncoding: "REST",
    attributions: options.attribution ? [options.attribution] : [],
  });
}
)});
  main.variable(observer("defaultResolutions")).define("defaultResolutions", function(){return(
[8960, 4480, 2240, 1120, 560, 280, 140, 70, 28, 14, 7, 2.8, 1.4, 0.7, 0.28, 0.14, 0.07]
)});
  main.variable(observer()).define(["md"], function(md){return(
md`### Libraries`
)});
  main.variable(observer("olModules")).define("olModules", async function(){return(
{
  Map: (await import("https://unpkg.com/ol@6.5.0/Map.js?module")).default,
  source: {
    WMTS: (await import("https://unpkg.com/ol@6.5.0/source/WMTS.js?module")).default,
    Vector: (await import("https://unpkg.com/ol@6.5.0/source/Vector.js?module")).default
  },
  extent: (await import("https://unpkg.com/ol@6.5.0/extent?module")),
  tilegrid: {
    ...(await import("https://unpkg.com/ol@6.5.0/tilegrid?module")),
    WMTS: (await import("https://unpkg.com/ol@6.5.0/tilegrid/WMTS.js?module")).default
  },
  layer: {
    Tile: (await import("https://unpkg.com/ol@6.5.0/layer/Tile.js?module")).default,
    Vector: (await import("https://unpkg.com/ol@6.5.0/layer/Vector.js?module")).default,
  },
  format: {
      GeoJSON: (await import("https://unpkg.com/ol@6.5.0/format/GeoJSON.js?module")).default
  },
  View: (await import("https://unpkg.com/ol@6.5.0/View.js?module")).default,
  proj: {
    ...(await import("https://unpkg.com/ol@6.5.0/proj?module")),
    proj4: (await import("https://unpkg.com/ol@6.5.0/proj/proj4?module"))
  }  
}
)});
  main.variable(observer("ol")).define("ol", ["olModules","proj"], function(olModules,proj)
{
  olModules.proj.proj4.register(proj);
  return olModules;
}
);
  main.variable(observer("css")).define("css", ["html"], function(html){return(
html`<link rel="stylesheet" href="https://unpkg.com/ol@6.5.0/ol.css">`
)});
  main.variable(observer("proj")).define("proj", ["require","epsg2193"], async function(require,epsg2193)
{
  let proj = await require('proj4').catch(() => window.proj4);
  proj.defs("EPSG:2193", epsg2193);
   
  return proj;
}
);
  main.variable(observer("epsg2193")).define("epsg2193", function(){return(
"+proj=tmerc +lat_0=0 +lon_0=173 +k=0.9996 +x_0=1600000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs +axis=neu"
)});
  main.variable(observer("dataUrl")).define("dataUrl", ["mapLoaded","viewof map"], function(mapLoaded,$0)
{
  return mapLoaded ? ($0).getElementsByTagName('canvas')[0].toDataURL() : undefined
}
);
  return main;
}
